import { Input, Label } from 'keep-react'
import { useRef } from 'react'

export const FormInput = ({
  formik,
  label,
  required,
  placeholder,
  name,
  type,
  extraClasses,
  inline,
  disabled,
  maxLength,
  onChange,
}: {
  formik: any
  label: string
  required?: boolean
  placeholder?: string
  name: string
  type: string
  extraClasses?: string
  inline?: boolean
  disabled?: boolean
  maxLength?: number
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}) => {
  const { error } = formik.getFieldMeta(name)
  const inputRef = useRef(null)

  const handleWheel = (e: React.WheelEvent<HTMLInputElement>) => {
    if (typeof e.cancelable !== 'boolean' || e.cancelable) {
      e.preventDefault()
    }
  }

  // Default change handler (for all fields except postal code)
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    formik.setFieldValue(name, e.target.value)
  }

  // Custom handler for Portuguese Postal Code formatting
  const handlePostalCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value.replace(/\D/g, '') // Remove non-numeric characters

    if (value.length > 4) {
      value = value.slice(0, 4) + '-' + value.slice(4, 7) // Auto-format "XXXX-XXX"
    }

    if (value.length > 8) {
      value = value.slice(0, 8) // Limit max length
    }

    formik.setFieldValue(name, value)
  }

  return (
    <div className="flex flex-col">
      <div
        className={`w-full ${inline ? 'items-center' : ''} ${
          extraClasses ?? ''
        }`}
      >
        {label && (
          <Label className={`text-body-4 block ${inline ? 'w-[40%]' : 'pb-2'}`}>
            {label}
            {required && <span className="text-primary-600">*</span>}
          </Label>
        )}
        <Input
          ref={inputRef}
          // Use onWheelCapture to avoid passive event listener warning
          onWheelCapture={handleWheel}
          onWheel={e => {
            if (type === 'number') {
              e.currentTarget.blur()
            }
          }}
          inputMode={type === 'number' ? 'numeric' : undefined}
          placeholder={placeholder}
          type={type}
          value={formik.values[name] || ''}
          disabled={disabled ? disabled : false}
          maxLength={maxLength}
          onChange={
            onChange
              ? onChange
              : type === 'postal_code'
              ? handlePostalCodeChange
              : handleChange
          }
        />
      </div>
      {error && (
        <span className="py-2 block w-full text-body-5 text-error-600">
          {error}
        </span>
      )}
    </div>
  )
}
